<button type="button" (click)="open()" [attr.aria-label]="picture.item_name || picture.docfilename" [class.picture-card--list]="view === 'list'">
    <span class="picture-card__media">
        <img *ngIf="!imageMissing" [ttImageSrc]="picture.url ?? ''" (ttImageSrcError)="onImageError()" (error)="onImageError()" [alt]="picture.item_name" />
        <span *ngIf="imageMissing" class="picture-card__missing">No image found</span>
    </span>
    <span *ngIf="view === 'list'" class="picture-card__details">
        <span class="picture-card__filename">{{ picture.item_name }}</span>
        <span *ngIf="picture.item_name !== (picture.fileName || picture.docfilename)">{{ picture.fileName || picture.docfilename }}</span>
        <span *ngIf="picture.registered_by">
            {{ picture.registered_by }}
            <ng-container *ngIf="picture.registered_datetime"> | {{ picture.registered_datetime | formatDate: "datetime" : false }}</ng-container>
            <ng-container *ngIf="picture.modified_datetime"> | {{ picture.modified_datetime | formatDate: "datetime" : false }}</ng-container>
        </span>
    </span>
</button>
